import { SxProps, Theme } from '@mui/material/styles';

export const repurchaseRootSX: SxProps<Theme> = {
	mb: { xs: '24px', md: '32px' },
};

export const repurchaseSectionSX: SxProps<Theme> = {
	padding: { xs: '16px 0 16px 16px', md: '16px 16px 18px' },
	mx: { xs: '-16px', md: 0 },
	background: '#F2F2F2',
	color: '#2c2c2c',
};

export const repurchaseHeaderSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: '16px',
	pr: { xs: '16px', md: 0 },
};

export const repurchaseCouponSlotSX: SxProps<Theme> = {
	pr: { xs: '16px', md: 0 },
};

export const repurchaseCouponAvailableSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
	gap: '4px',
	width: { xs: '100%', md: 'fit-content' },
	maxWidth: '100%',
	mt: { xs: '12px', md: '14px' },
	justifyContent: 'center',
	height: { md: '35px' },
	padding: { xs: '10px 12px', md: '0 16px' },
	boxSizing: 'border-box',
	border: '1px solid #E0EFFF',
	borderRadius: '4px',
	background: '#F4F9FF',
	color: '#2c2c2c',
	fontFamily: 'inherit',
	fontSize: { xs: '14px', md: '15px' },
	lineHeight: { xs: '20px', md: '22px' },
	textAlign: 'left',
	cursor: 'pointer',
	'&:focus-visible': { outline: '2px solid #0B6AD9', outlineOffset: '2px' },
};

export const repurchaseCouponAvailableHeadSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	gap: { xs: '10px', md: '5px' },
};

export const repurchaseCouponTextColumnSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '4px',
	minWidth: 0,
};

export const repurchaseCheckboxSX: SxProps<Theme> = {
	width: '22px',
	height: '22px',
	flexShrink: 0,
	boxSizing: 'border-box',
	border: '1.5px solid #BDBDBD',
	borderRadius: '4px',
	background: '#FFFFFF',
};

export const repurchaseCouponAppliedSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
	gap: '4px',
	width: { xs: '100%', md: 'fit-content' },
	maxWidth: '100%',
	mt: { xs: '12px', md: '14px' },
	justifyContent: 'center',
	height: { md: '35px' },
	padding: { xs: '9px 12px', md: '0 12px' },
	boxSizing: 'border-box',
	border: '1px solid #E0EFFF',
	borderRadius: '4px',
	background: '#F4F9FF',
	color: '#2c2c2c',
	fontSize: '15px',
	lineHeight: '21px',
};

export const repurchaseCouponAppliedHeadSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	color: '#0B6AD9',
};

export const repurchaseCarouselSX: SxProps<Theme> = {
	position: 'relative',
	mt: { xs: '12px', md: '14px' },
};

export const repurchaseNextButtonSX: SxProps<Theme> = {
	display: { xs: 'none', md: 'flex' },
	position: 'absolute',
	right: '-8px',
	top: '150px',
	alignItems: 'center',
	justifyContent: 'center',
	width: '44px',
	height: '44px',
	padding: 0,
	border: 0,
	borderRadius: '50%',
	background: '#FFFFFF',
	boxShadow: '0 4px 14px rgba(0,0,0,0.18)',
	cursor: 'pointer',
};
